<template>
  <div class="w-full h-0.5 bg-a-line my-3"></div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
